import { HttpClient } from '@angular/common/http'
import { LazyParams } from '@shared/components/table/table.models'
import { environment } from '@env'
import { map, share } from 'rxjs/operators'
import { logError } from '@shared/opretators/log-error.operator'
import { SortingService } from '@core/services/sorting/sorting.service'

export const getSales = (
  http: HttpClient,
  _sortingService: SortingService,
  params = {},
  lazyParams: LazyParams = {} as LazyParams,
) => {
  const paramsBackEnd = {
    filtering: {
      freeText: '',
      filterQuality: 'List',
      ...params,
    },
    ...lazyParams,
  }
  return http.post<any>(environment.API.SEARCH_SALES, paramsBackEnd).pipe(
    map((data) => ({
      ...data,
      paging: {
        totalRecords: data.sales.length,
        ...data.paging,
      },
      sorting: {
        ...data.sorting,
        ...lazyParams.sorting,
      },
      sales: _sortingService.sort(
        data.sales.map((sale) => ({
          ...sale,
          customerName: (sale.customer || {}).name,
          packageDescription: (sale.package || {}).description,
          packageName: (sale.package || {}).name,
          categoryName: (sale.category || {}).name,
          categoryId: (sale.category || {}).id,
        })),
      ),
    })),
    share(),
    logError(),
  )
}
